<template>
  <div class="header">
    <div class="left-content">
      DGSCGC <span class="logo-name-opacity">CREDILOG</span>
    </div>
    <div class="right-content">
      <div v-if="currentUser && currentUser.name">Bonjour <span class="label-name">{{ currentUser.name }}</span></div>
    </div>
  </div>
</template>

<script>
import { Component, BaseComponent, Getter, Action } from '@/libs/BaseComponent'

@Component({
})
export default class Header extends BaseComponent {
  @Getter('entities/users/currentUser') get currentUser () {}

  @Action('entities/users/logout') logout () {}
}
</script>

<style lang="scss" scoped>
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 48px;
    // background: #da140a;
    background-image: linear-gradient(to right, rgba(200, 10, 10, 1),rgba(200, 10, 10, 0.5));
    min-width:800px;

    .left-content {
      display: flex;
      align-items: center;
      font-size: 18px;
      width: 50%;
      padding: 0 80px 0 20px;
      color: #fff;
      height: 100%;
      // background-`image: linear-gradient(to right, #da140a, #da140a, #da140a, #fdd318);

      .logo-name-opacity {
        opacity: 0.9;
        padding-left: 6px;
        color: #fdd318;
      }
    }
    .right-content {
      display:flex;
      align-items: center;
      padding-right: 20px;
      font-size: 18px;
      color: #fff;

      .label-name {
        color: #fdd318;
      }
    }
  }
</style>
